import { useTranslations } from '@vocab/react';
import { TooltipRenderer, Text, Box } from 'braid-design-system';
import { useId, type FC } from 'react';

import translations from './.vocab';
import { HighFitBadge } from './HighFitBadge';
import type { Variant } from './variant';

type HighFitBadgeWithTooltipProps = {
  variant: Variant;
  applicantName: string;
};

export const HighFitBadgeWithTooltip: FC<HighFitBadgeWithTooltipProps> = ({
  variant,
  applicantName,
}) => {
  const { t } = useTranslations(translations);
  const id = useId();

  return (
    <TooltipRenderer
      id={id}
      placement="bottom"
      tooltip={
        <Text>
          {t('{applicantName} is a high-fit applicant', { applicantName })}
        </Text>
      }
    >
      {({ triggerProps }) => (
        <Box {...triggerProps} data={{ testid: 'high-fit-badge' }}>
          <HighFitBadge variant={variant} />
        </Box>
      )}
    </TooltipRenderer>
  );
};
